import React from 'react'
// eslint-disable-next-line @steelbrain/consistent-modules/default-import-match-filename
import Select from 'react-select/async'

import useAsyncDebouncedCallback from '@/client/hooks/useAsyncDebouncedCallback'

import { InputSelect } from '../styled'
import { FormContext, type FormInputType } from '../types'

const DEBOUNCE_TIME_MS = 100
const FormInputSelectAsync: React.FC<{
  input: FormInputType & { type: 'select-async' }
}> = ({ input }) => {
  const {
    name: inputName,
    onChange: inputOnChange,
    defaultOptions,
    isLoading = false,
    required = false,
  } = input
  const { submitting, onChange } = React.useContext(FormContext)
  const handleChange = React.useCallback(
    (value?: string) => {
      onChange(inputName, value ?? '')
      inputOnChange?.(value ?? '')
    },
    [inputName, inputOnChange, onChange]
  )

  const handleLoadOptions = useAsyncDebouncedCallback(input.loadOptions, {
    delayMs: DEBOUNCE_TIME_MS,
  })

  return (
    <InputSelect>
      <Select
        instanceId={input.name}
        name={input.name}
        cacheOptions
        loadOptions={inputValue => handleLoadOptions(inputValue)}
        placeholder={input.placeholder}
        isLoading={isLoading}
        onChange={e => handleChange(e?.value)}
        defaultInputValue={input.initialValue ?? undefined}
        defaultOptions={defaultOptions ?? true}
        isDisabled={submitting || input.disabled}
        isSearchable
        isClearable={required === false}
        styles={{
          control: base => ({
            ...base,
            borderColor: 'border',
          }),
        }}
      />
    </InputSelect>
  )
}

export default FormInputSelectAsync
